import './Page.css'
import React from "react";

export default function ContentW100({ bg, children }) {
    return (
        <div className="content-w100" style={{ backgroundColor: bg }}>
            {children}
        </div>
    )
}
